import { Controller } from 'stimulus';

export default class extends Controller {

  connect() {
    if (this.element.value != ''){
      this.count(this.element);
    }   
  }
   
  input() {
    this.count(this.element);
  }

  margin(){
    var base = document.querySelector(`input[name="${this.element.dataset.source}"]`).value;
    var percent = (parseFloat(this.element.value)+100)/100;
    if (base != '' && percent) {
      document.querySelector(`input[name="${this.element.dataset.field}"]`).value = (base*percent).toFixed(2); 
      this.count(document.querySelector(`input[name="${this.element.dataset.field}"]`)); 
    }  
  }

  count(e) {
    document.querySelector(`input[name="${e.dataset.field}"]`).value = (e.value*parseFloat(e.dataset.rate)).toFixed(2);
  }

  
}